import { ReactElement, useCallback } from 'react';
import { Stack } from '@mui/material';
import { TableChangeHandler } from 'react-bootstrap-table-next';

import {
  DataTable,
  DialogDetailsOrder,
  DialogFeedbackStop,
} from '~components/index';

import { useDashboardVariantV2GiverContentFinalizedTabContext } from '../../Context';

import { ITEM_KEY_ID } from '../../utils';
import { DashboardVariantV2GiverContentDataTableContainer } from '../../../../styles';

import { useFinalizedTabDataTableColumns } from './useColumns';

const DashboardVariantV2GiverContentFinalizedTabDataTable =
  (): ReactElement => {
    const {
      table: {
        data,
        loading: loadingRequestTable,
        totalSize,
        queryParams: { pagination },
        handleChangeTable: changeTable,
      },
      dialogs: {
        feedback: {
          open: openDialogFeedback,
          data: selectedDataForFeedback,
          handleClose: handleCloseDialogFeedback,
        },
        detailsOrder: {
          open: openDialogDetailsOrder,
          data: selectedDataForDetailsOrder,
          handleClose: handleCloseDialogDetailsOrder,
        },
      },
    } = useDashboardVariantV2GiverContentFinalizedTabContext();

    const columns = useFinalizedTabDataTableColumns();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChangeTable = useCallback<TableChangeHandler<any>>(
      (type, newState) => {
        changeTable(type, {
          pagination: { ...newState, sortField: newState?.sortField },
        });
      },
      [changeTable],
    );

    return (
      <>
        <Stack>
          <DashboardVariantV2GiverContentDataTableContainer>
            <DataTable
              loading={loadingRequestTable}
              data={data}
              columns={columns}
              keyField={ITEM_KEY_ID}
              pagination={{
                options: {
                  sizePerPage: pagination.sizePerPage,
                  page: pagination.page,
                  totalSize,
                },
              }}
              remote={{
                pagination: true,
                sort: true,
              }}
              onTableChange={handleChangeTable}
              hideableStorageKey="Dashboard-Giver-Finalized-Data-Table"
              toggleHideableColumns
              excludeHideableFieldColumns={['title', 'itemStateTypeId']}
            />
          </DashboardVariantV2GiverContentDataTableContainer>
        </Stack>

        {openDialogFeedback && selectedDataForFeedback && (
          <DialogFeedbackStop
            open={openDialogFeedback}
            onClose={handleCloseDialogFeedback}
            enabledFeebackPanel
            enabledChipTitle={false}
            {...selectedDataForFeedback}
          />
        )}

        {openDialogDetailsOrder && selectedDataForDetailsOrder && (
          <DialogDetailsOrder
            open={openDialogDetailsOrder}
            onClose={handleCloseDialogDetailsOrder}
            enabledChipTitle={false}
            {...selectedDataForDetailsOrder}
          />
        )}
      </>
    );
  };

export default DashboardVariantV2GiverContentFinalizedTabDataTable;
